import { Document, Page, PDFViewer, Text, View } from '@react-pdf/renderer';
import { EtiquetaVolumeDTO } from "./vendas.model";
import { IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { theme } from 'theme';

export type TEtiquetaVolume = {
    dadosEtiqueta: EtiquetaVolumeDTO,
    onGoBack: () => void
}

const EtiquetaVolume = (props: TEtiquetaVolume) => {
    return (
        <>
            <IconButton
                sx={{
                    zIndex: 100000,
                    position: 'absolute',
                    bottom: 20,
                    right: 30,
                    backgroundColor: theme.palette.primary.main,
                    ':hover': {
                        backgroundColor: theme.palette.primary.main,
                        filter: 'grayscale(.2) brightness(.8) contrast(1.5)'
                    }
                }}
                onClick={props.onGoBack}
            >
                <CloseIcon sx={{ color: theme.palette.background.default, fontSize: 45 }} />
            </IconButton>
            <PDFViewer
                style={{
                    zIndex: 10000,
                    width: '100%',
                    height: '100vh',
                    border: 0,
                    position: 'absolute',
                    top: 0,
                    left: 0,
                }}
                showToolbar={true}
            >
                <Document
                    title={props.dadosEtiqueta?.volume === 1 ? "Etiqueta de volume" : "Etiquetas de volumes"}
                    author={''}
                    language='pt-BR'
                >
                    {props.dadosEtiqueta &&
                        Array.from({ length: props.dadosEtiqueta?.volume ?? 1 }).map((_, i) => {
                            return (
                                <Page
                                    key={`page-etiqueta-${i}`}
                                    size={{ width: 297, height: 453 }}
                                    orientation="landscape"
                                    style={{
                                        backgroundColor: theme.palette.background.default,
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}
                                >
                                    <View style={{
                                        border: "1px solid black",
                                        width: "95%",
                                    }}>
                                        <View style={{
                                            maxHeight: "40px",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            paddingHorizontal: "5px",
                                            marginTop: "5px"

                                        }}>
                                            <Text style={{
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                            }}>
                                                Remetente:
                                            </Text>
                                            <Text style={{
                                                fontSize: "10px",
                                                marginLeft: "15px"
                                            }}>
                                                {props.dadosEtiqueta?.emitenteRazaoSocial}
                                            </Text>
                                        </View>

                                        <Text style={{
                                            fontSize: "10px",
                                            marginTop: "5px",
                                            paddingHorizontal: "5px"
                                        }}>
                                            {props.dadosEtiqueta?.emitenteLogradouro}
                                        </Text>


                                        <Text style={{
                                            fontSize: "10px",
                                            marginTop: "5px",
                                            paddingHorizontal: "5px"
                                        }}>
                                            {props.dadosEtiqueta?.emitenteComplemento}
                                        </Text>

                                        <Text style={{
                                            fontSize: "10px",
                                            marginTop: "5px",
                                            paddingHorizontal: "5px"
                                        }}>
                                            {props.dadosEtiqueta?.emitenteBairro}
                                        </Text>


                                        <View style={{
                                            flexDirection: "row",
                                            display: "flex",
                                            justifyContent: "space-around",
                                            borderBottom: "1px solid black",
                                            paddingHorizontal: "5px"

                                        }}>
                                            <View style={{
                                                flexDirection: "row",
                                                display: "flex",
                                                width: "50%",
                                                marginBottom: "5px"
                                            }}>
                                                <Text style={{
                                                    fontSize: "10px",
                                                    marginTop: "5px"
                                                }}>
                                                    {props.dadosEtiqueta?.emitenteCep}
                                                </Text>
                                                <Text style={{
                                                    fontSize: "10px",
                                                    marginTop: "5px",
                                                    marginLeft: "15px"
                                                }}>
                                                    {props.dadosEtiqueta?.emitenteCidadeEstado}
                                                </Text>
                                            </View>

                                            <View style={{
                                                width: "50%",
                                                display: "flex",
                                                alignItems: "flex-end"
                                            }}>
                                                <Text style={{
                                                    fontSize: "10px",
                                                    marginTop: "5px",
                                                    marginRight: "15px"
                                                }}>
                                                    {props.dadosEtiqueta?.emitenteTelefone}
                                                </Text>
                                            </View>
                                        </View>

                                        <View style={{
                                            maxHeight: "40px",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            paddingHorizontal: "5px",
                                            marginTop: "5px"
                                        }}>
                                            <Text style={{
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                                marginRight: "15px"
                                            }}>
                                                Destinatário:
                                                <Text style={{
                                                    fontSize: "10px",
                                                }}>
                                                    {"     "}  {props.dadosEtiqueta?.destinatarioRazaoSocial}
                                                </Text>
                                            </Text>

                                        </View>

                                        <Text style={{
                                            fontSize: "10px",
                                            marginTop: "5px",
                                            paddingHorizontal: "5px",
                                        }}>
                                            {props.dadosEtiqueta?.destinatarioLogradouro}, {props.dadosEtiqueta?.destinatarioNumero}
                                        </Text>


                                        <Text style={{
                                            fontSize: "10px",
                                            marginTop: "5px",
                                            paddingHorizontal: "5px"
                                        }}>
                                            {props.dadosEtiqueta?.destinatarioComplemento}
                                        </Text>

                                        <Text style={{
                                            fontSize: "10px",
                                            marginTop: "5px",
                                            paddingHorizontal: "5px"
                                        }}>
                                            {props.dadosEtiqueta?.destinatarioBairro}
                                        </Text>


                                        <View style={{
                                            flexDirection: "row",
                                            display: "flex",
                                            justifyContent: "space-around",
                                            borderBottom: "1px solid black",
                                            paddingHorizontal: "5px"
                                        }}>
                                            <View style={{
                                                flexDirection: "row",
                                                display: "flex",
                                                width: "50%",
                                                marginBottom: "5px"
                                            }}>
                                                <Text style={{
                                                    fontSize: "10px",
                                                    marginTop: "5px"
                                                }}>
                                                    {props.dadosEtiqueta?.destinatarioCep}
                                                </Text>
                                                <Text style={{
                                                    fontSize: "10px",
                                                    marginTop: "5px",
                                                    marginLeft: "15px"
                                                }}>
                                                    {props.dadosEtiqueta?.destinatarioCidadeEstado}
                                                </Text>
                                            </View>

                                            <View style={{
                                                width: "50%",
                                                display: "flex",
                                                alignItems: "flex-end"
                                            }}>
                                                <Text style={{
                                                    fontSize: "10px",
                                                    marginTop: "5px",
                                                    marginRight: "15px"
                                                }}>
                                                    {props.dadosEtiqueta?.destinatarioTelefone}
                                                </Text>
                                            </View>
                                        </View>
                                        <View style={{
                                            flexDirection: "row",
                                            display: "flex",
                                            borderBottom: "1px solid black",
                                            paddingHorizontal: "5px",
                                            paddingVertical: "5px"
                                        }}>
                                            <View style={{
                                                width: "50%"

                                            }}>
                                                <Text style={{
                                                    fontWeight: "bold",
                                                    fontSize: "24px",
                                                }}>
                                                    NF-e: {props.dadosEtiqueta?.notaSerie} - {props.dadosEtiqueta?.notaNumero}
                                                </Text>
                                            </View>
                                            <View style={{
                                                width: "50%",
                                                flexDirection: "row",
                                                justifyContent: "space-between",
                                                alignItems: "center"
                                            }}>
                                                <Text style={{
                                                    fontWeight: "bold",
                                                    fontSize: "10px",
                                                }}>
                                                    Data: {props.dadosEtiqueta?.dataFaturamento}
                                                </Text>
                                                <Text style={{
                                                    fontWeight: "bold",
                                                    fontSize: "10px",
                                                    marginRight: "15px",
                                                }}>
                                                    Pedido: {props.dadosEtiqueta?.pedidoNumero}/{props.dadosEtiqueta?.pedidoNumeroEntrega}
                                                </Text>
                                            </View>
                                        </View>

                                        <View style={{
                                            display: "flex",
                                            paddingHorizontal: "5px",
                                            paddingVertical: "5px",
                                        }}>
                                            <Text style={{
                                                fontSize: "10px",
                                                marginTop: "5px",
                                                fontWeight: "bold",
                                            }}>
                                                Transportadora: {""}
                                                <Text style={{
                                                    fontSize: "12px",
                                                }}>
                                                    {props.dadosEtiqueta?.transportadoraRazaoSocial}
                                                </Text>
                                            </Text>

                                            <Text style={{
                                                fontSize: "10px",
                                                marginTop: "5px",
                                            }}>
                                                Volume(s): {""}
                                                <Text>
                                                    {i + 1} / {props.dadosEtiqueta?.volume}
                                                </Text>
                                            </Text>
                                        </View>
                                    </View>
                                </Page>
                            )
                        })
                    }
                </Document>
            </PDFViewer>
        </>
    )
}
export default EtiquetaVolume
